import type { CSSProperties, ReactNode } from "react";
import { cn } from "@/lib/utils";

type Tone = "emergency" | "neutral" | "dangerSolid";

interface TagProps {
  tone?: Tone;
  children: ReactNode;
  className?: string;
}

/**
 * Status pill — Figma §5.3.
 * - emergency:   "Shoshilinch yig'im" — danger-tint fon, danger matn
 * - neutral:     "Operatsiya" / "Reabilitatsiya" — line fon, primary matn
 * - dangerSolid: detail header "Shoshilinch" — to'liq qizil, oq matn
 */
export function Tag({ tone = "neutral", children, className }: TagProps) {
  const styles: Record<Tone, CSSProperties> = {
    emergency: { background: "var(--c-danger-tint)", color: "var(--c-danger)" },
    // --c-line brendga bog'liq "stroke" tokeni — fill uchun --c-elevated-2 (brand-agnostic, CountBadge bilan bir xil).
    neutral: { background: "var(--c-elevated-2)", color: "var(--c-text)" },
    dangerSolid: { background: "var(--c-danger)", color: "#ffffff" },
  };
  return (
    <span
      style={styles[tone]}
      className={cn(
        "inline-flex h-[25px] items-center rounded-[20px] px-2 text-xs font-medium tracking-[0.2px] whitespace-nowrap",
        tone === "dangerSolid" && "rounded-full",
        className,
      )}
    >
      {children}
    </span>
  );
}

/** Yumaloq son badge — chip/filter trailing yoki count uchun (Figma §5.2 / caption). */
export function CountBadge({
  children,
  selected = false,
  className,
}: {
  children: ReactNode;
  selected?: boolean;
  className?: string;
}) {
  return (
    <span
      style={
        selected
          ? { background: "rgba(255,255,255,0.2)", color: "inherit" }
          : { background: "var(--c-elevated-2)", color: "var(--c-text-muted)" }
      }
      className={cn(
        "inline-flex h-5 min-w-5 items-center justify-center rounded-full px-1 text-[10px] font-medium tracking-[0.2px]",
        className,
      )}
    >
      {children}
    </span>
  );
}
